import { RouteConfig } from 'vue-router';

import { beforeEnterIncomeTaxCalculator } from './navigation-guards/income-tax-calculator';

import UpdateUserAccountView from '@/modules/account/views/UpdateUserAccount/UpdateUserAccountView.vue';
import { IncomeTaxCalculator } from '@/modules/account/views/IncomeTaxCalculator';
import { regulatoryUpdateRoutes } from '../views/RegulatoryUpdate/routes';
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';

export const accountRoutes: RouteConfig[] = [
  ...regulatoryUpdateRoutes,
  {
    name: 'user-email',
    path: '/user/email',
    redirect: () => {
      const { domain } = getDomainAndPlatform();
      return (window.location.href = `/onboarding/${domain}/desktop/change-email`);
    }
  },
  {
    name: 'user-account',
    path: '/user/account',
    component: UpdateUserAccountView,
    meta: {
      context: 'account'
    }
  },
  {
    name: 'incomeTaxCalculator',
    path: '/user/income-tax-calculator',
    component: IncomeTaxCalculator,
    beforeEnter: beforeEnterIncomeTaxCalculator,
    meta: {
      context: 'account'
    }
  }
];
